import type { EditControlProps } from '../../declare'
import { useState } from 'react'
import { Input } from 'antd'
import { EasyIcon } from 'src/components'

const PasswordInput = (props: EditControlProps) => {
  const [visible, setVisible] = useState(false)

  const handleChange = (evt: any) => {
    props.onChange?.(evt.target.value)
  }

  const { __READONLY__, EDITABLE, PROMPT_INFO } = props.config
  return (
    <Input
      type={visible ? undefined : 'password'}
      disabled={__READONLY__ || !EDITABLE || props.evtConfig?.disabled}
      placeholder={PROMPT_INFO}
      value={props.value}
      onChange={handleChange}
      addonAfter={
        <EasyIcon
          type={visible ? 'EyeInvisibleOutlined' : 'EyeOutlined'}
          onClick={() => setVisible(!visible)}
        />
      }
    />
  )
}

export default PasswordInput